export default __webpack_public_path__ + "static/media/account_setup.f82940ae.svg";